'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _components = require('../components');

var _organizations = require('redux/modules/organizations');

var _tags = require('redux/modules/tags');

var _types = require('redux/modules/types');

var _venues = require('redux/modules/venues');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    indexOrganizations: function indexOrganizations(showAll, treeView, query, flush) {
      dispatch((0, _organizations.index)(showAll, treeView, query, flush));
    },
    setShowAllOrganizations: function setShowAllOrganizations(value) {
      dispatch((0, _organizations.setShowAll)(value));
    },
    setTreeViewOrganizations: function setTreeViewOrganizations(value) {
      dispatch((0, _organizations.setTreeView)(value));
    },
    toggleDisclosedOrganizations: function toggleDisclosedOrganizations(value) {
      dispatch((0, _organizations.toggleDisclosed)(value));
    },
    indexTags: function indexTags(showAll, treeView, query, flush) {
      dispatch((0, _tags.index)(showAll, treeView, query, flush));
    },
    setShowAllTags: function setShowAllTags(value) {
      dispatch((0, _tags.setShowAll)(value));
    },
    setTreeViewTags: function setTreeViewTags(value) {
      dispatch((0, _tags.setTreeView)(value));
    },
    toggleDisclosedTags: function toggleDisclosedTags(value) {
      dispatch((0, _tags.toggleDisclosed)(value));
    },
    indexTypes: function indexTypes(showAll, treeView, query, flush) {
      dispatch((0, _types.index)(showAll, treeView, query, flush));
    },
    setShowAllTypes: function setShowAllTypes(value) {
      dispatch((0, _types.setShowAll)(value));
    },
    setTreeViewTypes: function setTreeViewTypes(value) {
      dispatch((0, _types.setTreeView)(value));
    },
    toggleDisclosedTypes: function toggleDisclosedTypes(value) {
      dispatch((0, _types.toggleDisclosed)(value));
    },
    indexVenues: function indexVenues(showAll, treeView, query, flush) {
      dispatch((0, _venues.index)(showAll, treeView, query, flush));
    },
    setShowAllVenues: function setShowAllVenues(value) {
      dispatch((0, _venues.setShowAll)(value));
    },
    setTreeViewVenues: function setTreeViewVenues(value) {
      dispatch((0, _venues.setTreeView)(value));
    },
    toggleDisclosedVenues: function toggleDisclosedVenues(value) {
      dispatch((0, _venues.toggleDisclosed)(value));
    },
    push: function push(value) {
      dispatch((0, _reduxRouter.push)(value));
    }
  };
};

var EntitiesContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    organizations: {
      data: state.organizations.data,
      showAll: state.organizations.showAll,
      treeView: state.organizations.treeView,
      disclosed: state.organizations.disclosed
    },
    tags: {
      data: state.tags.data,
      showAll: state.tags.showAll,
      treeView: state.tags.treeView,
      disclosed: state.tags.disclosed
    },
    types: {
      data: state.types.data,
      showAll: state.types.showAll,
      treeView: state.types.treeView,
      disclosed: state.types.disclosed
    },
    venues: {
      data: state.venues.data,
      showAll: state.venues.showAll,
      treeView: state.venues.treeView,
      disclosed: state.venues.disclosed
    },
    location: state.router.location
  };
}, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EntitiesContainer, _Component);

  function EntitiesContainer(props) {
    (0, _classCallCheck3.default)(this, EntitiesContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EntitiesContainer.__proto__ || (0, _getPrototypeOf2.default)(EntitiesContainer)).call(this, props));

    _this.actions = {
      organizations: {
        index: _this.props.indexOrganizations,
        setShowAll: _this.props.setShowAllOrganizations,
        setTreeView: _this.props.setTreeViewOrganizations,
        toggleDisclosed: _this.props.toggleDisclosedOrganizations
      },
      tags: {
        index: _this.props.indexTags,
        setShowAll: _this.props.setShowAllTags,
        setTreeView: _this.props.setTreeViewTags,
        toggleDisclosed: _this.props.toggleDisclosedTags
      },
      types: {
        index: _this.props.indexTypes,
        setShowAll: _this.props.setShowAllTypes,
        setTreeView: _this.props.setTreeViewTypes,
        toggleDisclosed: _this.props.toggleDisclosedTypes
      },
      venues: {
        index: _this.props.indexVenues,
        setShowAll: _this.props.setShowAllVenues,
        setTreeView: _this.props.setTreeViewVenues,
        toggleDisclosed: _this.props.toggleDisclosedVenues
      }
    };
    return _this;
  }

  (0, _createClass3.default)(EntitiesContainer, [{
    key: 'handleToggleDisclosure',
    value: function handleToggleDisclosure(entityId) {
      var entity = this.props.entity;

      this.actions[entity].toggleDisclosed(entityId);
    }
  }, {
    key: 'handleToggleShowAll',
    value: function handleToggleShowAll() {
      var entity = this.props.entity;

      var newShowAll = !this.props[entity].showAll;
      var treeView = this.props[entity].treeView;

      this.actions[entity].setShowAll(newShowAll);
      this.actions[entity].index(newShowAll, treeView, {}, !newShowAll);
    }
  }, {
    key: 'handleToggleTreeView',
    value: function handleToggleTreeView() {
      var entity = this.props.entity;

      var showAll = this.props[entity].showAll;
      var newTreeView = !this.props[entity].treeView;

      this.actions[entity].setTreeView(!this.props[entity].treeView);
      this.actions[entity].index(showAll, newTreeView, {}, showAll);
    }
  }, {
    key: 'render',
    value: function render() {
      var entity = this.props.entity;
      var entities = this.props[entity].data;
      var showAll = this.props[entity].showAll;
      var treeView = this.props[entity].treeView;

      var entitiesTree = [];
      var entitiesById = {};
      var childrenByParentId = {};
      var sortByName = function sortByName(eA, eB) {
        return eA.name.localeCompare(eB.name);
      };

      if (treeView) {
        entities.forEach(function (en) {
          entitiesById[en.id] = en;
          if (en.parent_id) {
            childrenByParentId[en.parent_id] = childrenByParentId[en.parent_id] || [];
            childrenByParentId[en.parent_id].push(en);
          } else {
            childrenByParentId[en.id] = childrenByParentId[en.id] || [];
            en.children = childrenByParentId[en.id];
            entitiesTree.push(en);
          }
        });

        entitiesTree.sort(sortByName);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(childrenByParentId)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var childId = _step.value;

            childrenByParentId[childId].sort(sortByName);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      var props = {
        disclosed: this.props[entity].disclosed,
        entity: entity,
        entities: entities,
        entitiesTree: entitiesTree,
        push: this.props.push,
        showAll: showAll,
        treeView: treeView,
        handleToggleDisclosure: this.handleToggleDisclosure.bind(this),
        handleToggleShowAll: this.handleToggleShowAll.bind(this),
        handleToggleTreeView: this.handleToggleTreeView.bind(this)
      };

      return _react2.default.createElement(_components.Entities, props);
    }
  }]);
  return EntitiesContainer;
}(_react.Component), _class2.propTypes = {
  entity: _react.PropTypes.string.isRequired,
  indexOrganizations: _react.PropTypes.func.isRequired,
  indexTags: _react.PropTypes.func.isRequired,
  indexTypes: _react.PropTypes.func.isRequired,
  indexVenues: _react.PropTypes.func.isRequired,
  organizations: _react.PropTypes.object.isRequired,
  push: _react.PropTypes.func.isRequired,
  setShowAllOrganizations: _react.PropTypes.func.isRequired,
  setShowAllTags: _react.PropTypes.func.isRequired,
  setShowAllTypes: _react.PropTypes.func.isRequired,
  setShowAllVenues: _react.PropTypes.func.isRequired,
  setTreeViewOrganizations: _react.PropTypes.func.isRequired,
  setTreeViewTags: _react.PropTypes.func.isRequired,
  setTreeViewTypes: _react.PropTypes.func.isRequired,
  setTreeViewVenues: _react.PropTypes.func.isRequired,
  toggleDisclosedOrganizations: _react.PropTypes.func.isRequired,
  toggleDisclosedTags: _react.PropTypes.func.isRequired,
  toggleDisclosedTypes: _react.PropTypes.func.isRequired,
  toggleDisclosedVenues: _react.PropTypes.func.isRequired,
  tags: _react.PropTypes.object.isRequired,
  types: _react.PropTypes.object.isRequired,
  venues: _react.PropTypes.object.isRequired
}, _class2.contextTypes = {
  moment: _react.PropTypes.func
}, _temp)) || _class);
exports.default = EntitiesContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EntitiesContainer.js
// module id = 1176
// module chunks = 0